import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function ForWhomSection() {
  return <section className="w-full py-20 px-6 pt-[30px] pb-[30px]" style={{
    background: 'var(--cream)'
  }} aria-label="Para quién es este libro" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <div className="text-center mb-14" data-id="element-115">
          <p className="text-sm font-bold tracking-widest uppercase mb-4" style={{
          color: 'var(--gold-dark)'
        }} data-id="element-116">
            Antes de Comprar
          </p>
          <h2 className="text-4xl md:text-5xl font-bold" style={{
          color: 'var(--brown)'
        }} data-id="element-117">
            ¿Para Quién Es Este Libro?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-118">
          {/* For you */}
          <div className="rounded-2xl overflow-hidden shadow-md" data-id="element-119">
            <div className="px-8 py-5" style={{
            background: 'var(--sage)',
            color: 'white'
          }} data-id="element-120">
              <h3 className="text-xl font-bold" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-121">
                ✅ DULCE LIBERTAD es para ti si:
              </h3>
            </div>
            <div className="px-8 py-8 flex flex-col gap-5" style={{
            background: 'var(--cream)'
          }} data-id="element-122">
              <div className="flex items-start gap-4" data-id="element-123">
                <CheckCircleIcon className="w-5 h-5 flex-shrink-0 mt-1" style={{
                color: 'var(--sage)'
              }} aria-hidden="true" data-id="element-124" />
                <p style={{
                color: 'var(--brown-light)'
              }} data-id="element-125">
                  Tienes celiaquía diagnosticada y extrañas los postres que
                  comías antes
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-126">
                <CheckCircleIcon className="w-5 h-5 flex-shrink-0 mt-1" style={{
                color: 'var(--sage)'
              }} aria-hidden="true" data-id="element-127" />
                <p style={{
                color: 'var(--brown-light)'
              }} data-id="element-128">
                  Tu hijo tiene intolerancia al gluten o a los lácteos y quieres
                  que no se sienta diferente en las fiestas
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-129">
                <CheckCircleIcon className="w-5 h-5 flex-shrink-0 mt-1" style={{
                color: 'var(--sage)'
              }} aria-hidden="true" data-id="element-130" />
                <p style={{
                color: 'var(--brown-light)'
              }} data-id="element-131">
                  Sufres de colon irritable, SOP o inflamación crónica y buscas
                  postres que no te inflamen
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-132">
                <CheckCircleIcon className="w-5 h-5 flex-shrink-0 mt-1" style={{
                color: 'var(--sage)'
              }} aria-hidden="true" data-id="element-133" />
                <p style={{
                color: 'var(--brown-light)'
              }} data-id="element-134">
                  Eres diabética o pre-diabética y quieres recuperar el placer
                  del dulce sin afectar tu glucosa
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-135">
                <CheckCircleIcon className="w-5 h-5 flex-shrink-0 mt-1" style={{
                color: 'var(--sage)'
              }} aria-hidden="true" data-id="element-136" />
                <p style={{
                color: 'var(--brown-light)'
              }} data-id="element-137">
                  Sigues una alimentación consciente y antiinflamatoria pero no
                  quieres renunciar a los postres
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-138">
                <CheckCircleIcon className="w-5 h-5 flex-shrink-0 mt-1" style={{
                color: 'var(--sage)'
              }} aria-hidden="true" data-id="element-139" />
                <p style={{
                color: 'var(--brown-light)'
              }} data-id="element-140">
                  Vives en LATAM y estás harta de recetas con ingredientes
                  imposibles de conseguir
                </p>
              </div>
            </div>
          </div>

          {/* Not for you */}
          <div className="rounded-2xl overflow-hidden shadow-md" data-id="element-141">
            <div className="px-8 py-5" style={{
            background: 'var(--brown-light)',
            color: 'white'
          }} data-id="element-142">
              <h3 className="text-xl font-bold" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-143">
                ❌ DULCE LIBERTAD NO es para ti si:
              </h3>
            </div>
            <div className="px-8 py-8 flex flex-col gap-5" style={{
            background: 'var(--cream-dark)'
          }} data-id="element-144">
              <div className="flex items-start gap-4" data-id="element-145">
                <XCircleIcon className="w-5 h-5 flex-shrink-0 mt-1" style={{
                color: 'var(--blush)'
              }} aria-hidden="true" data-id="element-146" />
                <p style={{
                color: 'var(--brown-light)'
              }} data-id="element-147">
                  Buscas recetas rápidas sin aprender el sistema detrás
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-148">
                <XCircleIcon className="w-5 h-5 flex-shrink-0 mt-1" style={{
                color: 'var(--blush)'
              }} aria-hidden="true" data-id="element-149" />
                <p style={{
                color: 'var(--brown-light)'
              }} data-id="element-150">
                  No estás dispuesta a invertir tiempo en entender por qué
                  funcionan las técnicas
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-151">
                <XCircleIcon className="w-5 h-5 flex-shrink-0 mt-1" style={{
                color: 'var(--blush)'
              }} aria-hidden="true" data-id="element-152" />
                <p style={{
                color: 'var(--brown-light)'
              }} data-id="element-153">
                  Esperas resultados perfectos la primera vez sin practicar
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}